import {
    ApplicationConfig,
    enableProdMode,
    importProvidersFrom,
} from "@angular/core";

import { env } from "../environments/env";
import { structuredMerge } from "../functions/structuredMerge";
import { APP_SETTINGS, AppSettings } from "./app.settings";
import { provideRouter } from "@angular/router";
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient } from "@angular/common/http";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { CookieInterceptor } from "./core/interceptor/http-cookie.interceptor";
import { routes } from "./app.routes";

import { provideTranslateService, TranslateService } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";
import { provideXmlReport } from "@otimo/highcharts-xmlreport";
import { MessagingService } from "@otimo/messaging";
import { LangService, LoggingService, SharedReportsService, RouteDataService } from "@otimo/report-base";
import { CookieService } from "ngx-cookie-service";

import "@angular/common/locales/global/sv";
import { EnvironmentProviders } from '@angular/core';

const appConfig: ApplicationConfig = {
    providers: [
        importProvidersFrom(FormsModule, NgbModule, BrowserModule),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CookieInterceptor,
            multi: true,
        },
        MessagingService,
        LangService,
        Location,
        LoggingService,
        SharedReportsService,
        RouteDataService,
        CookieService,
        provideRouter(routes),
        provideTranslateService({
                lang: "sv",
                fallbackLang: "sv",
                loader: provideTranslateHttpLoader({
                    prefix: "api/translations/",
                    suffix: ""
            })
        }),
        provideXmlReport()
    ]
};

export async function getApplicationConfig(): Promise<ApplicationConfig | null> {
    const baseHref = (document.getElementsByTagName("base")[0] || {}).href;

    try {
        const response = await fetch(`${baseHref}api/settings`);
        const backendSettings = await response.json();

        if (env.production) {
            enableProdMode();
            window.console.debug = function () {
                /* disable any console.debug debugging statements in production mode */
            };
        }

        // Merge environment with settings
        const settings = new AppSettings();
        structuredMerge(settings, env, backendSettings);
        // Get href from base element
        if (settings.baseHref == "") settings.baseHref = baseHref;

        if (!env.production) console.log(settings);

        appConfig.providers.push({ provide: APP_SETTINGS, useValue: settings });

        return appConfig;
    } catch (error) {
        alert("Ingen kontakt med servern!");
        return null;
    }
}
